import { Modal } from "antd";

export const PopUp = (props) => {
  const { onCancel, content, title, visibility, width } = props;

  return (
    <Modal
      centered
      closable={false}
      wrapClassName={props.class}
      open={visibility}
      title={title && title}
      footer={null}
      width={width}
      onCancel={onCancel}
      destroyOnClose={true}
    >
      {content}
    </Modal>
  );
};
